import { createFileRoute } from "@tanstack/react-router";
import { IntegrateTopicPage } from "@/components/IntegrateTopicPage";
import { withMemberGate } from "@/lib/with-member-gate";

export const Route = createFileRoute("/integrate/micro-adventures")({
  // The topic content is fetched when this page opens, not on every visit.
  loader: async () => {
    const { getIntegrateTopic } = await import("@/data/integrate-topics");
    return { topic: getIntegrateTopic("micro-adventures")! };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ name: "robots", content: "noindex" }] };
    const topic = loaderData.topic;
    const url = `https://recoverytrauma.com/integrate/${topic.slug}`;
    const title = `${topic.title} — Recovery Trauma™`;
    return {
      meta: [
        { title },
        // Member-gated shell — the public view is only a lock screen.
        { name: "robots", content: "noindex" },
        { name: "description", content: topic.intro },
        { property: "og:title", content: title },
        { property: "og:description", content: topic.intro },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: withMemberGate(TopicRoute, "Micro Adventures"),
});

function TopicRoute() {
  const { topic } = Route.useLoaderData();
  return <IntegrateTopicPage topic={topic} />;
}
